import React from "react"
import { alertShow } from "../config/Helpers";

class Alerts extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            rows_models  : "",
            rows_reports : ""
        }
    }

    handleClick(type){
        this.props.alertState(type)
    }
    render(){
        return (
            <div> </div>
        )
    }
}

export default Alerts


// WEBPACK FOOTER //
// ./src/Frontend/components/Alerts.js